module.exports = __webpack_public_path__ + "img/img12.18f4caae.jpg";